import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Divider,
  Tabs,
  Tab,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useEffect, useState } from 'react';
import { TabPanel } from '../../../../components/tab-panel';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { equipmentApiKeyStore } from '../../../../api/masters/equipment-api-key-store';
import { historyColumns } from './grid-columns';
import { SaveHistoryComponent } from './save-history.component';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { useAuthorize } from '../../../../hooks/use-authorize';

interface SkillSetDialogProps {
  equipmentID: any;
  isOpen: boolean;
  onCloseClick: () => void;
}

export const HistoryDialog = ({ equipmentID, isOpen, onCloseClick }: SkillSetDialogProps) => {
  // const { isLoading, data } = useLoadData<ApiResponse<any>>(usersApiKeyStore.getUserSkillSets(employeeID));

  const [value, setValue] = useState('create');
  const [editItem, setEditItem] = useState<any>();

  const handleSaveEquipmentHistory = () => {
    setEditItem(undefined);
    setValue('view');
  };
  const handleEdit = (value: any) => {
    setEditItem(value);
    setValue('edit');
  };

  const handleTabsChange = (event: any, value: any) => {
    if (value == "view") setEditItem(undefined);
    setValue(value);
  };

  const isMunicipalityPermission = !useAuthorize([UserPermissionName?.EDIT_EQUIPMENT]);

  useEffect(() => {
    if (isMunicipalityPermission) setValue('view');
  }, [isMunicipalityPermission])

  return (
    <Dialog
      open={isOpen}
      fullWidth={true}
      maxWidth={'lg'}
      // onClose={onCloseClick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="dialog-title" sx={{ p: 0, m: 0 }}>
        <Tabs value={value} onChange={handleTabsChange}>
          <Tab value="view" label={<div>VIEW SERVICE HISTORY</div>} />
          <Tab value="create" label={<div>ADD SERVICE HISTORY</div>} hidden={isMunicipalityPermission || !!editItem} />
          <Tab value="edit" label={<div>EDIT SERVICE HISTORY</div>} hidden={!editItem} />
        </Tabs>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onCloseClick}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers className="popupDilog">
        <TabPanel selectedValue={value} value="view">
          <SiTrackGrid
            fileTitle='equipment_history'
            dataItemKey="equipmentCalibrationHistoryID"
            columns={historyColumns}
            queryConfig={equipmentApiKeyStore.getEquipmentCalibrationById(equipmentID)}
            onEdit={handleEdit}
            deleteMutationConfig={(item) =>
              equipmentApiKeyStore.deleteEquipmentCalibration(item.equipmentCalibrationHistoryID)
            }
            actionPermissions={{
              edit: UserPermissionName.EDIT_EQUIPMENT,
              delete: UserPermissionName.EDIT_EQUIPMENT,
              export: UserPermissionName.DOWNLOAD_GRID,
            }}
          />
        </TabPanel>
        <TabPanel selectedValue={value} value="create">
          <SaveHistoryComponent
            onSaveHistory={handleSaveEquipmentHistory}
            onClosed={onCloseClick}
            equipmentID={equipmentID}
          />
        </TabPanel>
        <TabPanel selectedValue={value} value="edit">
          <SaveHistoryComponent
            onSaveHistory={handleSaveEquipmentHistory}
            onClosed={onCloseClick}
            equipmentID={equipmentID}
            equipmentHistory={editItem}
          />
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
};
